import React from 'react'
import styles from '../styles'
import logo from '../assets/logo.jpeg'
import { NavLink } from 'react-router-dom'

const Footer = () => {
  const isActiveStyle = 'border-b-2 mx-3 border-white font-extrabold transaction-all duration-200 ease-in-out hover:shadow-xl py-1'
  const isNotActiveStyle = 'pl-3 hover:font-extrabold transaction-all duration-200 ease-in-out capitalize hover:shadow-xl py-1'
  
  return (
    <div className={`${styles.flexCenter}  ${styles.paddingY} border-t-2 border-green-800 md:mx-[1px] bg-primary md:px-4`}>
        <div className={` flex flex-col md:flex-row mb-8 w-full`}>
            <div className='flex flex-1 flex-col justify-start mr-10 relative'>
              <div className='first-letter:z-[0] w-[50%] h-[50%] right-20 bottom-20'></div>
                <div className='z-[1] w-[80%] h-[85%] rounded-full bottom-40 '></div>
                <img src={logo} alt="LOGO" className='object-contain w-[266px] h-[76px] rounded-lg'/>
                <p className={`max-w-[310px] mt-4 text-gradient text-lg p-3 flex flex-col`}>
                    <span className='font-semibold'>Mlimi wamakono app</span> 
                    <span className='font-extralight'> - First agricultural online learning platform in Malawi</span>
                </p>
            </div>
            <div className="flex flex-[1.5] md:flex-row flex-col justify-between flex-wrap md:mt-0 mt-10 gap-y-10 text-white">
               <div className='flex flex-col items-start'>
                <h1 className='text-lg font-semibold font-poppins mb-[7px]'>Common Links</h1>
                <ul className='flex flex-col gap-y-2'>
                   <NavLink
                      to={"/"}
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      Home
                    </NavLink>

                    <NavLink
                      to ="/about"
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      About Us
                    </NavLink>

                    <NavLink
                      to={"/courses"}
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      Courses
                    </NavLink>

                    <NavLink
                      to={"partners"}
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      Partners
                    </NavLink>

                    <NavLink
                      to={"contactUs"}
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      Contact Us
                    </NavLink>

                    <hr className='border-1 border-green-600 mt-4'/>
                    <NavLink
                      to={"register"}
                      className = {({isActive}) => isActive ? isActiveStyle : isNotActiveStyle }
                    >
                      Register
                    </NavLink>
                </ul>
               </div>

               <div className='flex flex-col items-start'>
                <h1 className='text-lg font-semibold font-poppins mb-[7px]'>Some Courses</h1>
                <ul className='flex flex-col'>
                  <li>1. Poultry production</li>
                  <li>2. Maize production</li>
                  <li>3. Winter cropping</li>
                  <li>4. Vegetable Production </li>
                  <li>5. Pig Farming </li>
                  <li>6. Fruit Production </li>
                  <li>7. Pepper Production </li>
                  <li>8. Groundnuts Production </li>
                </ul>
               </div>

              <div className='flex flex-col items-start'>
                <h1 className='text-lg font-semibold font-poppins mb-[7px]'>Contact Us</h1>
                <ul className='flex flex-col items-start gap-y-2'>
                  <li>+265 997 000 631</li>
                  <li>+265 884 981 662</li>
                  <li>mlimiwamakono@gmail.com</li>
                </ul>
              </div>
            </div>
        </div>
        
    </div>
  )
}

export default Footer
